import {
  AccountInfo,
  PublicClientApplication,
  RedirectRequest,
} from '@azure/msal-browser'
import {
  loginRequest,
  MSAL_CONFIG,
} from '../config/azure-authentication-config'

export class SignInRequiredError extends Error {
  constructor(message) {
    super(message)
    this.constructor = SignInRequiredError
    this.message = message
  }
}

export const msalInstance =
  process.env.TestExecutingContext || false
    ? null
    : new PublicClientApplication(MSAL_CONFIG) //SEE setupTest.ts

export class AuthenticationService {
  private client: PublicClientApplication

  constructor(pca: PublicClientApplication) {
    this.client = pca
  }

  async getAccessToken(): Promise<string> {
    try {
      const account = await this.getAccount()

      const accessTokenRequest = {
        scopes: loginRequest.scopes,
        account: account,
      }

      const response = await this.client.acquireTokenSilent(accessTokenRequest)

      return Promise.resolve(response.accessToken)
    } catch (error) {
      return Promise.reject(
        new SignInRequiredError('User is required to sign in.')
      )
    }
  }

  async getAccount(): Promise<AccountInfo> {
    const accounts = this.client.getAllAccounts()
    if (accounts === null || accounts.length === 0) {
      return Promise.reject(
        new SignInRequiredError('User is required to sign in.')
      )
    }
    return Promise.resolve(accounts[0])
  }

  /*
    This function will navigate away from the current browser window. 
    It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
    */
  async redirect() {
    const account = this.client.getActiveAccount()
    const accessTokenRequest: RedirectRequest = {
      scopes: loginRequest.scopes,
      account: account,
    }

    await this.client.acquireTokenRedirect(accessTokenRequest)
  }
}
